export default class NewsletterSignupModal {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'newsletter-signup-modal-mounted':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Permission acceptflow',
                    'eventAction': 'Impression',
                    'eventLabel': 'Permission popup',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'newsletter-signup-modal-signup-form-closed-by-cross':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Permission acceptflow',
                    'eventAction': 'Luk tilmeld',
                    'eventLabel': 'Permission popup',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'newsletter-signup-modal-confirmation-closed-by-cross':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Permission acceptflow',
                    'eventAction': 'Luk kvittering - kryds',
                    'eventLabel': 'Permission popup',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            case 'newsletter-signup-modal-confirmation-closed-by-button':
                trackingObject = {
                    "event": "track-event",
                    "eventCategory": "Permission acceptflow",
                    "eventAction": "Luk kvittering - knap",
                    "eventLabel": "Permission popup",
                    "eventValue": "0",
                    "eventNoninteraction": true,
                    "data": null
                };
                break;
            case 'newsletter-signup-modal-submit-permission':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Permission acceptflow',
                    'eventAction': 'Klik tilmeld',
                    'eventLabel': 'Permission popup',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
        }

        return trackingObject;
    }
}
